import React from 'react';
import { useFormContext } from 'react-hook-form';
import CurrencyInput from 'common-mui/components/CurrencyInput';
import useApplication from '../../resources/applications/read';
import useRepair from '../../resources/repairs/read';
import { currencyFormat } from '../../constants';

const InputFinancingAmount = () => {
  const { data: application } = useApplication();
  const { data: repair } = useRepair();
  const { control, watch } = useFormContext();

  return (
    <CurrencyInput
      name="financingAmount"
      label="Financing Amount"
      control={control}
      watch={watch}
      rules={{
        required: 'This field is required.',
        min: {
          value: 350,
          message: 'Financing amount cannot be less than $350.00',
        },
        validate: {
          maxTransactionTotal: (value) => (
            value <= +repair.attributes.total_amount
          || `Financing amount cannot be more than the transaction total of ${currencyFormat.format(repair.attributes.total_amount)}`
          ),
          maxApprovedAmount: (value) => (
            value <= +application.attributes.max_approved_amount
          || `Financing amount cannot be more than your max approved amount of ${currencyFormat.format(application.attributes.max_approved_amount)}`
          ),
        },
      }}
    />
  );
};

export default InputFinancingAmount;
